import script from "./RemoveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"RemoveButton.vue"]])

export default __exports__